import React, { useState, useEffect, useContext } from "react";
import { Button, Modal, Select, Form } from 'antd';
import { Row, Col } from "react-bootstrap";
import konsole from "../../network/konsole";
import Services from "../../network/Services";
import { UserContext } from "../../App";
import { universalPayment } from "../../control/Constant";
import { EventBaseUrl, CounterBaseUrl, CounterMobileBaseUrl, AoAdminBaseUrl, AoPartnerBaseUrl, AoAcaddemyUrl, IntakeEntryBaseUrl, lpoiceLink, AoAgenturl, intakeBaseUrl, lpoLiteUrl } from "../../network/url";

const { Option } = Select;

const AccountRoleChange = ({ isOpen, onClose }) => {
    const [selectedRoleId, setSelectedRoleId] = useState('');
    const [form] = Form.useForm();
    const globalData = useContext(UserContext)
    const { loggedInUserRoles, setLoggedInUserRoles, setLoader } = globalData;
    const [isErrorSomethinWrong, setIsErrorSomethingWrong] = useState(false)
    const [isDisabled, setisDisabled] = useState(false)
    const AccountReceivableId = "AR";
    const PortalSignOnRoleId = "PortalSignOn";

    // console.log("loggedInUserRoles", loggedInUserRoles)
    useEffect(() => {
        if (loggedInUserRoles?.length == 0) {
            fetchRole();
        }
    }, []);

    const fetchRole = () => {
        let userId = sessionStorage.getItem('loggedUserId');
        let roleUserId = sessionStorage.getItem('roleUserId');
        setLoader(true);
        Services.getUserDetailsByUserEmailId({ userId })
            .then((res) => {
                konsole.log("response", res);
                setLoader(false);
                if (res?.data?.length > 0) {
                    const resData = res.data[0];
                    const userRoles = resData?.roleDetails?.filter((item) => item.roleId != roleUserId && item?.roleId != 1 && item?.roleId != 2 && item?.roleId != 20 & item.roleId != 9 && item.roleId != 7 && item.roleId != 8 && item.roleId != 12 && item.roleId != 19 && item.roleId != 17 && item.roleId != 18)?.map((i) => ({ ...i, value: i.roleId, label: i.roleName }));
                    konsole.log("userRoles", userRoles);
                    const sortOrder = [3, 13, 14, 15, 4, 11, 6, 16];
                    let sortedRoles = [...userRoles]?.sort((a, b) => {
                        const indexA = sortOrder?.indexOf(Number(a.roleId));
                        const indexB = sortOrder?.indexOf(Number(b.roleId));

                        if (indexA === -1 && indexB === -1) return 0;
                        if (indexA === -1) return 1;
                        if (indexB === -1) return -1;
                        return indexA - indexB;
                    });
                       sortedRoles.push({
                        roleId: AccountReceivableId,
                        roleName: 'Accounts Receivable',
                        userId: userId,
                        value:AccountReceivableId,
                        label : 'Accounts Receivable'
                    });
                    setLoggedInUserRoles(sortedRoles);
                }
            })
            .catch((err) => {
                setLoader(false);
                konsole.log("Error", err);
            });
    };
    const handleChange = (e) => {
        setIsErrorSomethingWrong(false)
        setSelectedRoleId(e);
    };
    function getRoleLabel(roleId) {
        const urlMap = {
            '1': intakeBaseUrl + 'login',
            '3': intakeBaseUrl,
            '4': AoAdminBaseUrl,
            '5': AoAgenturl,
            '6': CounterBaseUrl,
            '8': CounterBaseUrl,
            '10': intakeBaseUrl,
            '11': AoAdminBaseUrl,
            '13': intakeBaseUrl,
            '14': intakeBaseUrl,
            '15': intakeBaseUrl,
            '16': CounterMobileBaseUrl,
            '21': IntakeEntryBaseUrl,
            [AccountReceivableId]: universalPayment + "/login",
        };
        return urlMap[roleId] || '';
    }

    const handleSubmit = () => {
        setisDisabled(true)
        form
            .validateFields()
            .then((values) => {
                konsole.log('Selected Role ID:', selectedRoleId);
                konsole.log("valuesvalues", values)

                let stateObj = JSON.parse(sessionStorage.getItem('stateObj'));
                let loggedInUserId = sessionStorage.getItem('loggedUserId');

                let isAR_Selected = selectedRoleId == AccountReceivableId;
                let isLegalStaff = selectedRoleId == PortalSignOnRoleId;
                // let roleId = values?.roleId;
                   let roleId = (isLegalStaff || isAR_Selected) ? stateObj?.roleId :  selectedRoleId;
                let tokenKey = `appState=${stateObj?.appState}&userId=${loggedInUserId}&roleId=${roleId}&loggenInId=${stateObj?.loggenInId}${isAR_Selected ? `&paymentDashboard=true` : ''}`;
                // console.log("tokenKey", tokenKey)
                // let roleUrl = getRoleLabel(roleId);
                let roleUrl = getRoleLabel(selectedRoleId);
                if (!(roleUrl != undefined && roleUrl != null && roleUrl != '')) {
                    setIsErrorSomethingWrong(true);
                    return;
                }
                konsole.log("roleUrl", roleUrl);
                let redirectUrl = `${roleUrl}?token=${window.btoa(tokenKey)}`
                // window.open(redirectUrl, "_blank");
                sessionStorage.clear();
                window.location.replace(redirectUrl);

            })
            .catch((errorInfo) => {
                konsole.log('Validation Failed:', errorInfo);
                setisDisabled(false)
            });
    };

    konsole.log("loginMemberRoles", loggedInUserRoles);
    konsole.log("globalData", globalData);

    return (
        <>
                    <Modal
                        className="Account-Role-Change"
                        visible={isOpen}
                        footer={null}
                        closable={false}
                        centered={true}
                        enforceFocus={false}
                        maskClosable={false}
                        bodyStyle={{ padding: '0px'}}>

                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', 
                    padding: '14px 16px 12px 16px', borderBottom: '1px solid #bfbfbf' }}>
                    <p style={{ fontSize: '16px', fontWeight: '700', color: '#333333', margin: 0 }}>Account</p>
                    <span onClick={onClose} style={{ cursor: 'pointer', fontSize: '25px', color: '#333333', lineHeight: 1, padding: '2px 6px' }}>×</span>
                    </div>
                        <div className="mt-2 mb-4">
                            <Form form={form}>
                                <Row>
                                    <Col className="d-flex justify-content-center mt-3">

                                        <div>
                                            {(isErrorSomethinWrong == true) && <div className="text-danger mb-2" >Something went wrong.Please try again after some time. </div>}
                                            <div className="fw-bold" style={{fontSize:"14px"}}>Please pick a role for this visit</div>
                                            <Form.Item
                                                name="roleId"
                                                rules={[{ required: true, message: "Please select a role" }]}
                                                style={{ marginTop: "2px" }}>
                                                <Select
                                                    name="roleId"
                                                    placeholder="Select"
                                                    style={{ width: 300 }}
                                                    onChange={handleChange}
                                                    value={selectedRoleId}>
                                                    {loggedInUserRoles.map((item, index) => (
                                                        <Option value={item.value} key={item.label}>
                                                            {item.label}
                                                        </Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                            <div className="d-flex justify-content-center pt-4">
                                                <Button disabled={isDisabled} onClick={handleSubmit} 
                                                style={{ "background-color": "#720C20",  height:"44px", 
                                                    minWidth:"90px",
                                                color: "white", borderRadius: "2px"}} >
                                                    Continue
                                                </Button>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </Form>
                        </div>
                    </Modal>
        </>
    );
};

export default AccountRoleChange;
